// 监控目前是通过固定的C位曝光上报事件和参数, 然后在AntMonitor创建规则筛选日志、配置监控项
import { getSpmParams } from '../logger/spmParams';
import { IquicInfo } from '../logger/interface';

// 固定的用来上报监控事件的spmId
const MonitorEventSpmId = 'a1702.b62549.c318491';

export const iMonitor = {
  logEvent(eventName: string, params?: Record<string, any>) {
    try {
      window.iTracker.expo(MonitorEventSpmId, {
        eventName,
        ...params,
      });
    } catch (err) {
      console.log(err);
    }
  },

  logComponentEvent(
    eventName: string,
    componentSpmData: IquicInfo,
    params?: Record<string, any>,
  ) {
    try {
      const { spmId, spmTag, spmParams } = getSpmParams(componentSpmData);
      window.iTracker.expo(MonitorEventSpmId, {
        eventName,
        spmId,
        ...spmTag,
        ...spmParams,
        ...params,
      });
    } catch (err) {
      console.log(err);
    }
  },
};

// 提供全局变量供页面组件上报监控
Object.defineProperty(window, 'iMonitor', {
  value: iMonitor,
  writable: false,
  configurable: false,
});
